export { benefitsFilterLego } from './benefitsFilterLego';
export { howItWorkFilterLego } from './howWorkFilterLego';
export { whyLiftFilterLego } from './whyLiftFilterLego';
export { funnelReviewsFilterLego } from './funnelReviewsFilterLego';
